import type { User } from '@teachur/http-client';

export interface EnrolledPlan {
  degreeName: string;
  degreeType: string;
}

const DEGREE_TYPE_ORDER = ['associate', 'bachelor', 'master'];

export const getEnrolledPlan = (user: User | undefined): EnrolledPlan | null => {
  const degrees = (user?.enrolledDegrees ?? [])
    .map((enrolled) => enrolled.degree)
    .filter((degree): degree is NonNullable<typeof degree> => degree != null)
    .sort((a, b) => DEGREE_TYPE_ORDER.indexOf(a.type) - DEGREE_TYPE_ORDER.indexOf(b.type));
  const primary = degrees[degrees.length - 1];
  if (!primary) {
    return null;
  }
  return {
    degreeName: degrees.map((degree) => degree.name).join(' and '),
    degreeType: primary.type,
  };
};
